<template>
  <AppSheetProjectElementLarge
    :title="neighbourhoodSubdivision.name"
    :enter-to="neighbourhoodSubdivisionRouteObject"
    :exterior-tour360-to="exteriorTour360RouteObject"
    :logo-image-url="logoUrl"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import NeighbourhoodSubdivision from '@/classes/ProjectStructure/NeighbourhoodSubdivision'
import AppSheetProjectElementLarge from '@/components/UIKit/Standard/Organisms/AppSheet/AppSheetProjectElementLarge'
import responsiveMixin from '@/mixins/responsiveMixin'
import NeighbourhoodSubdivisionRouteObjectGenerator from '@/classes/RouteObjectGenerators/NeighbourhoodSubdivisionRouteObjectGenerator'
import ExteriorTour360RouteObjectGenerator from '@/classes/RouteObjectGenerators/ExteriorTour360RouteObjectGenerator'

export default {
  name: 'NeighbourhoodSubdivisionPanelContent',
  components: {
    AppSheetProjectElementLarge,
  },
  mixins: [responsiveMixin],
  props: {
    projectElement: {
      type: NeighbourhoodSubdivision,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      logoData: 'Project/logo',
    }),
    neighbourhoodSubdivision() {
      return this.projectElement
    },
    shouldDisplayLogo() {
      return this.isSmallScreenHorizontal && this.logoData.display
    },
    logoUrl() {
      return this.shouldDisplayLogo ? this.logoData.imgUrl : undefined
    },
    neighbourhoodSubdivisionRouteObject() {
      const params = {
        useTransition: true,
        hideUIControlsDuringTransition: true,
      }
      return NeighbourhoodSubdivisionRouteObjectGenerator.make(
        this.neighbourhoodSubdivision,
        params
      )
    },
    haveExteriorTour360() {
      return !!this.neighbourhoodSubdivision.exteriorTour360Url
    },
    exteriorTour360RouteObject() {
      return this.haveExteriorTour360
        ? ExteriorTour360RouteObjectGenerator.make(
            this.neighbourhoodSubdivision
          )
        : undefined
    },
  },
}
</script>
